import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableHighlight,
  Platform,
  Dimensions,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";
import { ArButton } from "../argon-ui";
import * as Actions from "../actions/ScenarioActions";
import * as CONSTS from "../../assets/consts";
import PropTypes from "prop-types";
import ScenarioModel from "../viewModels/Scenario";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faPlus,
  faQuestionCircle,
  faStopwatch,
  faLightbulb,
  faHandPointUp,
  faToggleOn,
  faToggleOff,
  faWandMagic,
} from "../../assets/consts/faCharCodes";
import MiniAddButton from "../components/MiniAddButton";
import ScenarioSummary from "../components/scenarios/ScenarioSummary";
import * as AreaHelper from "../actions/AreaHelper";
import { getScenarioIconByMainCondition } from "../actions/ScenarioHelper";
import Theme from "../argon-ui/Theme";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import MessageBox from "../components_v2/MessageBox";
import { Modal, VStack } from "native-base";
import ModalBase from "../nativeBase-ui/ModalBase";
const SCREEN_WIDTH = Dimensions.get("window").width;
const MODAL_MODES = {
  NONE: "",
  SUMMARY: "summary",
  EXECUTE: "execute",
  DELETE: "delete",
  EDIT: "edit",
  REPORT: "report",
};

class ScenarioListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      showMiniAdd: false,
      accessToken: "",
      modalIsVisible: false,
      modalMode: MODAL_MODES.NONE,
      selectedScenario: undefined,
      selectedScenarioId: undefined,
      selectedScenarioUId: undefined,
      searchQuery: "",
      selectedScenarioOption: "",
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.ScenarioList"),
  });
  componentDidMount() {
    this.setState({
      accessToken: this.props.appReducer?.currentServer.accessToken,
      isLoading: false,
    });
  }
  getOption() {
    let options = [];
    let { canEdit, canDelete } = this.findScenario(
      this.state.selectedScenarioId || this.state.selectedScenarioUId
    );
    if (canDelete) {
      options.push({
        label: translate("app.delete"),
        value: MODAL_MODES.DELETE,
      });
    }
    if (canEdit) {
      options.push({ label: translate("app.edit"), value: MODAL_MODES.EDIT });
    }
    options.push({ label: translate("app.report"), value: MODAL_MODES.REPORT });
    return options;
  }
  componentWillUnmount() {
    this.hideModal();
  }
  navigateFormFor = (destination) => {
    this.setState({ showMiniAdd: false });
    this.props.navigation.navigate("ScenarioForm", {
      mainConditionType: destination,
    });
  };

  navigateForEdit = (scenarioId) => {
    this.hideModal();

    this.props.navigation.navigate("ScenarioForm", {
      scenarioId,
    });
  };
  navigateForReport = (scenarioId, scenarioUId, scenarioName) => {
    this.hideModal();

    this.props.navigation.navigate("ScenarioReport", {
      scenarioId,
      scenarioUId,
      scenarioName,
    });
  };
  showSummary = (scenario) => {
    //console.log("show summary for scenario", scenario);

    this.setState({
      selectedScenario: scenario,
      selectedScenarioId: scenario?.id,
      selectedScenarioUId: scenario?.uId,
      modalIsVisible: true,
      modalMode: MODAL_MODES.SUMMARY,
    });
  };

  hideModal = () => {
    this.setState({
      selectedScenario: undefined,
      selectedScenarioId: undefined,
      selectedScenarioUId: undefined,
      modalIsVisible: false,
      modalMode: MODAL_MODES.NONE,
      selectedScenarioOption: "",
    });
  };

  findScenario = (scenarioId) => {
    for (let i = 0; i < this.props.reducer.scenarios.length; i++) {
      const scenario = this.props.reducer.scenarios[i];
      if ((scenario.id || scenario.uId) == scenarioId) {
        let _model = new ScenarioModel();
        Object.assign(_model, scenario);
        return _model;
      }
    }
    return new ScenarioModel();
  };

  renderSummary = () => {
    var _mainConditionType = undefined;
    let { selectedScenarioId, selectedScenarioUId } = this.state;
    var selectedScenario = this.findScenario(
      selectedScenarioId || selectedScenarioUId
    );
    let { canEdit, canDelete, canRun } = selectedScenario;
    if (selectedScenario) {
      _mainConditionType = selectedScenario._mainConditionType;
    }
    if (selectedScenario) {
      const actions = selectedScenario.getActionReverse();
      var dictionary = AreaHelper.getActionReverseDictionary(
        this.props.AreaReducer.actionManagers,
        actions
      );
      return (
        <View style={[style.modalInsideWrapper, { width: "100%" }]}>
          <ScrollView style={{ width: "90%" }}>
            <ScenarioSummary
              scenarioId={this.state.selectedScenarioId}
              scenarioUId={this.state.selectedScenarioUId}
              hasDetail={selectedScenario.hasDetail}
              enable={selectedScenario.enable}
              actionReverseDictionary={dictionary}
              style={{ flex: 1 }}
            />
          </ScrollView>

          {(_mainConditionType == CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE ||
            _mainConditionType == CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL) &&
            canRun && (
              <ArButton
                color="primary"
                onPress={() =>
                  this.setState({ modalMode: MODAL_MODES.EXECUTE })
                }
                style={style.modalBtn}
              >
                {translate("scenario.executeNow")}
              </ArButton>
            )}
          {/* {canDelete && (
            <ArButton
              color="error"
              onPress={() => this.setState({ modalMode: MODAL_MODES.DELETE })}
              style={style.modalBtn}
            >
              {translate("app.delete")}
            </ArButton>
          )} */}
        </View>
      );
    } else {
      return <View style={style.modalInsideWrapper}></View>;
    }
  };

  renderExecuteConfirm = () => {
    //@TODO: for virtual scenarios, only show confirm button

    //@TODO: for schedule scenarios, show nextTick and ask for update or ignore nextTick

    return (
      <View
        style={[
          style.modalInsideWrapper,
          {
            width: "100%",
            paddingHorizontal: 0,
          },
        ]}
      >
        <Text style={[style.h1, { marginTop: 10 }]}>
          {this.state.selectedScenario.name}
        </Text>
        <Text style={{ flex: 1, marginVertical: 10 }}>
          {translate("scenario.itemWillExecute")}
        </Text>
        <ArButton
          color="primary"
          onPress={() => {
            let { selectedScenarioId, selectedScenarioUId, accessToken } =
              this.state;
            if ((selectedScenarioId || selectedScenarioUId) && accessToken) {
              this.props.runScenario(
                selectedScenarioId,
                selectedScenarioUId,
                accessToken
              );
              this.setState({
                modalMode: MODAL_MODES.SUMMARY,
              });
              // this.hideModal();
            }
          }}
          style={style.modalBtn}
        >
          {translate("scenario.executeNow")}
        </ArButton>
      </View>
    );
  };

  renderDeleteConfirm = () => {
    return (
      <View
        style={[
          style.modalInsideWrapper,
          {
            width: "100%",
            justifyContent: "space-between",
            paddingHorizontal: 0,
          },
        ]}
      >
        <VStack space="3" mb="3">
          <Text style={style.h1}>{this.state.selectedScenario.name}</Text>
          <Text>{translate("app.itemWillDelete")}</Text>
        </VStack>
        <ArButton
          color="error"
          onPress={() => {
            let { selectedScenarioId, selectedScenarioUId, accessToken } =
              this.state;
            if ((selectedScenarioId || selectedScenarioUId) && accessToken) {
              this.props.removeScenario(
                selectedScenarioId,
                selectedScenarioUId,
                accessToken
              );
              this.hideModal();
            }
          }}
          style={style.modalBtn}
        >
          {translate("app.delete")}
        </ArButton>
      </View>
    );
  };

  render() {
    let scenarioOptions = [];
    let { canEdit, canDelete } = this.state.selectedScenario || {};
    if (canEdit) {
      scenarioOptions.push({
        label: translate("app.edit"),
        value: MODAL_MODES.EDIT,
      });
    }
    scenarioOptions.push({
      label: translate("app.report"),
      value: MODAL_MODES.REPORT,
    });
    if (canDelete) {
      scenarioOptions.push({
        label: translate("app.delete"),
        value: MODAL_MODES.DELETE,
      });
    }
    return (
      <View style={{ flex: 1 }}>
        {/**search */}
        <InputSearch
          onChangeText={(txt) => {
            this.setState({ searchQuery: txt });
          }}
          value={this.state.searchQuery}
        />
        <ScrollView
          style={{
            flex: 1,
            marginBottom: 85,
            borderTopWidth: 1,
            borderColor: Theme.COLORS.MUTED,
            padding: 5,
          }}
        >
          {this.props.reducer.scenarios.length == 0 ? (
            <View style={{ paddingHorizontal: 10 }}>
              <MessageBox icon={faWandMagic}>
                {translate("app.emptyList")}
              </MessageBox>
            </View>
          ) : (
            this.props.reducer.scenarios
              .filter(
                (s) =>
                  !this.state.searchQuery ||
                  s.name.indexOf(this.state.searchQuery) >= 0
              )
              .map((s) => {
                return (
                  <ScenarioListItem
                    key={s.id || s.uId}
                    scenario={s}
                    onPress={(scenario) => s.canView && this.showSummary(s)}
                  />
                );
              })
          )}
          {this.state.modalIsVisible && (
            <ModalBase
              closeButton={false}
              isOpen={this.state.modalIsVisible}
              onClose={() => this.hideModal()}
              contentStyle={{ height: "100%" }}
            >
              <View style={style.modalInsideContainer}>
                {/* toggle enable button */}
                {this.state.selectedScenario &&
                  this.state.selectedScenario.canEdit && (
                    <View
                      style={{
                        flexDirection:
                          Platform.OS == "web" ? "row" : "row-reverse",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <TouchableHighlight
                        underlayColor="#e2e2e2"
                        style={style.btnToggle}
                        onPress={() => {
                          let { id, enable } = this.state.selectedScenario;
                          this.props.toggleEnable(
                            id,
                            !enable,
                            this.state.accessToken
                          );
                        }}
                      >
                        <View>
                          <FontAwesomeIcon
                            icon={
                              this.state.selectedScenario.enable
                                ? faToggleOn
                                : faToggleOff
                            }
                            color={
                              this.state.selectedScenario.enable
                                ? Theme.COLORS.ACTIVE
                                : Theme.COLORS.MUTED
                            }
                            size={32}
                          />
                        </View>
                      </TouchableHighlight>

                      <View
                        style={{
                          width: Platform.OS == "web" ? 180 : 120,
                          marginEnd: 10,
                        }}
                      >
                        {/* <FontAwesomeIcon
                          icon={faEdit}
                          color={Theme.COLORS.ACTIVE}
                          size={28}
                        /> */}
                        <Select
                          data={this.getOption()}
                          placeholder={translate("app.options")}
                          value={this.state.selectedScenarioOption}
                          onChangeText={(value, index, data) => {
                            if (value == "") {
                              this.setState({
                                modalMode: MODAL_MODES.SUMMARY,
                                selectedScenarioOption: value,
                              });
                            } else {
                              this.setState({
                                modalMode: value,
                                selectedScenarioOption: value,
                              });
                              let { id, uId, name } =
                                this.state.selectedScenario;
                              var _id = id || uId;
                              if (value == MODAL_MODES.EDIT) {
                                this.navigateForEdit(_id);
                              }
                              if (value == MODAL_MODES.REPORT) {
                                this.navigateForReport(id, uId, name);
                              }
                            }
                          }}
                        />
                      </View>
                    </View>
                  )}
                {/* toggle enable button */}

                {this.state.modalMode == MODAL_MODES.SUMMARY &&
                  this.renderSummary()}
                {this.state.modalMode == MODAL_MODES.EXECUTE &&
                  this.renderExecuteConfirm()}
                {this.state.modalMode == MODAL_MODES.DELETE &&
                  this.renderDeleteConfirm()}

                {/* cancel button */}
                {/* <ArButton
                  color="muted"
                  onPress={() => {
                    this.hideModal();
                  }}
                  style={style.modalBtn}
                >
                  {translate("app.cancel")}
                </ArButton> */}
                {/* /cancel button */}
              </View>
            </ModalBase>
          )}
        </ScrollView>

        {this.state.showMiniAdd && (
          <Modal
            isOpen={this.state.showMiniAdd}
            onClose={() =>
              this.setState({ showMiniAdd: !this.state.showMiniAdd })
            }
          >
            <View style={style.btnMiniAddHoler}>
              <MiniAddButton
                icon={faStopwatch}
                text={translate("scenario.schedule")}
                onPress={() => {
                  this.navigateFormFor("schedule");
                }}
              />
              <MiniAddButton
                icon={faLightbulb}
                text={translate("scenario.device")}
                onPress={() => {
                  this.navigateFormFor("device");
                }}
              />
              <MiniAddButton
                icon={faHandPointUp}
                text={translate("scenario.virtual")}
                onPress={() => {
                  this.navigateFormFor("virtual");
                }}
              />
            </View>
          </Modal>
        )}
        {this.props.AreaReducer.areas.some(
          (a) => a.accessLevel == "Admin" || a.accessLevel == "Support"
        ) && (
          <TouchableHighlight
            style={style.btnAdd}
            onPress={() => {
              this.setState({ showMiniAdd: !this.state.showMiniAdd });
            }}
          >
            <FontAwesomeIcon icon={faPlus} size={25} color="#FFF" />
          </TouchableHighlight>
        )}
      </View>
    );
  }
}

/**@augments {Component<props, state>}*/
export class ScenarioListItem extends Component {
  static propTypes = {
    scenario: PropTypes.object,
    onPress: PropTypes.func,
  };
  handleOnPress = () => {
    this.props.onPress && this.props.onPress();
  };

  render() {
    let s = new ScenarioModel();
    Object.assign(s, this.props.scenario);
    let mainCondition = s.getMainCondition();
    let icon = faQuestionCircle;
    let scenarioIcon = getScenarioIconByMainCondition(mainCondition);
    if (scenarioIcon) {
      icon = scenarioIcon;
    }
    return (
      <TouchableHighlight
        onPress={this.handleOnPress}
        underlayColor={Theme.COLORS.LIGHT_MAIN}
        style={s.enable ? style.listItemEnable : style.listItemDisable}
        key={s.id}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 10,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              flex: 1,
            }}
          >
            <View
              style={{
                width: 36,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FontAwesomeIcon
                icon={icon}
                color={s.enable ? Theme.COLORS.TL_PURPLE : Theme.COLORS.MUTED}
                size={28}
              />
            </View>
            <Text
              style={{
                paddingHorizontal: 5,
                fontSize: 16,
                flex: 1,
              }}
            >
              {s.name}
              {/* {s.enable ? "" : `(${translate("scenario.disable")})`} */}
            </Text>
          </View>
          <Text
            style={{
              paddingHorizontal: 5,
              fontSize: 12,
            }}
          >
            {/* {s.name} */}
            {s.enable ? "" : `${translate("scenario.disable")}`}
          </Text>
        </View>
      </TouchableHighlight>
    );
  }
}

const style = StyleSheet.create({
  btnAdd: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: Theme.COLORS.PRIMARY,
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  btnMiniAdd: {
    width: 50,
    height: 50,
    borderRadius: 25,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 15,
    alignSelf: "center",
    marginBottom: 5,
  },
  btnMiniAddTitle: {
    backgroundColor: "#000000",
    color: "#fff",
    borderRadius: 10,
    textAlign: "center",
    marginBottom: 10,
    fontSize: 16,
  },
  btnMiniAddHoler: {
    position: "absolute",
    bottom: 60,
    alignSelf: "center",
  },
  btnToggle: {
    padding: 5,
    marginHorizontal: 12,
    width: 52,
    height: 52,
    borderRadius: 26,
    alignSelf: "flex-start",
  },
  btnEdit: {
    padding: 5,
    marginHorizontal: 12,
    width: 52,
    height: 52,
    borderRadius: 26,
    alignSelf: "flex-end",
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  hint: {
    textAlign: "center",
    color: Theme.COLORS.MUTED,
  },
  listItemEnable: {
    justifyContent: "center",
    height: 55,
    // padding: 16,
    marginBottom: 5,
    // marginHorizontal: 3,
    // borderBottomColor: Theme.COLORS.MUTED,
    // borderBottomWidth: 1,
    backgroundColor: Theme.COLORS.WHITE,
    borderRadius: 5,
  },

  listItemDisable: {
    justifyContent: "center",
    height: 56,
    // padding: 16,
    marginBottom: 5,
    marginHorizontal: 3,
    borderBottomColor: Theme.COLORS.MUTED,
    borderBottomWidth: 1,
    backgroundColor: Theme.COLORS.INPUT,
    borderRadius: 5,
  },
  modalBtn: {
    width: "100%",
    marginBottom: 0,
  },
  modalInsideContainer: {
    padding: 10,
    flex: 1,
    marginBottom: 0,
    height: "100%",
    alignItems: "center",
    minHeight: 200,
  },
  modalInsideWrapper: {
    flex: 1,
    margin: 20,
    marginBottom: 0,
    height: "100%",
    alignItems: "center",
  },
  h1: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: 3,
    borderBottomColor: "#ccc",
    borderBottomWidth: 1,
    marginHorizontal: 6,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.ScenarioReducer,
    AreaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeScenario: (scenarioId, scenarioUId, accessToken) =>
      dispatch(Actions.Remove(scenarioId, scenarioUId, accessToken)),
    runScenario: (scenarioId, scenarioUId, accessToken) =>
      dispatch(Actions.RunScenario(scenarioId, scenarioUId, accessToken)),
    toggleEnable: (scenarioId, enable, accessToken) =>
      dispatch(Actions.ToggleEnable(scenarioId, enable, accessToken)),
    getDetails: (scenarioId, scenarioUId, accessToken) =>
      dispatch(Actions.GetDetails(scenarioId, scenarioUId, accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioListScreen);
